module.exports = require("./th-TH");